import React, { forwardRef } from 'react';
import Link from 'next/link';

// workaround for Next.js v12
export const MenuLink = forwardRef<
  HTMLAnchorElement,
  JSX.IntrinsicElements['a']
>((props, ref) => {
  const { href, children, ...rest } = props;
  return (
    <Link href={href}>
      <a ref={ref} {...rest}>
        {children}
      </a>
    </Link>
  );
});

MenuLink.displayName = 'MenuLink';
